import { providePrimeNG } from 'primeng/config';

import { provideRouter } from '@angular/router';
import { withInterceptors, provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { MessageService } from 'primeng/api';

import { SvgIconModule } from '@/app/shared/components/ui/svg-icon';

import { provideEventPlugins } from '@/app/shared/utils/event-plugins';

import { AppRoutes } from '@/app/core/routes';
import { authInterceptor } from '@/app/core/interceptors/auth';
import { refreshInterceptor } from '@/app/core/interceptors/refresh';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideAnimationsAsync(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor, refreshInterceptor])),
    provideRouter(AppRoutes),
    provideEventPlugins(),
    providePrimeNG({
      translation: {
        firstDayOfWeek: 1,
        dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    }),
    importProvidersFrom(
      SvgIconModule.forRoot({
        spriteUrl: '/assets/icons/sprite.svg',
      }),
    ),
  ],
};
